import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'formatdate',
  standalone: true
})
export class FormatDateService implements PipeTransform {
  private readonly TPHL_TIMEZONE = 'America/New_York';

  transform(value: string | Date, format: 'short' | 'full' = 'short'): string {
    if (!value) {
      return '';
    }
    return format === 'short' ? this.formatShortDate(value) : this.formatFullDate(value);
  }

  formatShortDate(date: string | Date): string {
    const dateStr = typeof date === 'string' ? date : date.toISOString();
    const [year, month, day] = dateStr.split('T')[0].split('-');
    return `${month}/${day}/${year}`;
  }
  formatMonthYearDate(date: string | Date): string {
    const dateStr = typeof date === 'string' ? date : date.toISOString();
    const [year, month] = dateStr.split('T')[0].split('-');
    return `${month}/${year}`;
  }

  formatFullDate(date: string | Date): string {
    const dateObj = new Date(date);
    return dateObj.toLocaleString('en-US', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).replace(/,(?=[^,]*$)/, '.');
  }

  formatFullDateWithTphlTimezone(date: string | Date): string {
    const dateObj = new Date(date);
    
    const formattedDate = dateObj.toLocaleString('en-US', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZone: this.TPHL_TIMEZONE
    }).replace(/,(?=[^,]*$)/, '.');
    
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: this.TPHL_TIMEZONE,
      timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(dateObj);
    const timeZoneName = parts.find(part => part.type === 'timeZoneName')?.value || '';
    const timeZoneAbbr = timeZoneName.includes('EDT') ? 'EDT' : 'EST';
    
    return `${formattedDate} ${timeZoneAbbr}`;
  }
}